/* © NXAPP Limited */

/**
 * Starter content for a new plain email: body space, a personal signature, and
 * the legal disclaimer.
 *
 * {{companyName}} / {{companyWebsite}} are merged from the sending profile at
 * send time, so the disclaimer always names the company the mail is sent as.
 * Because this includes {{UNSUBSCRIBE_URL}}, the automatic fallback footer will
 * not fire — this block replaces it.
 */

const DISCLAIMER_STYLE = 'font-size:8px;line-height:1.4;color:#555555;'   // 6pt, dark grey

export const PLAIN_STARTER_HTML = `<p>Hi {{firstName}},</p>
<p><br/></p>
<p><br/></p>
<p>Best regards,</p>
<p><br/></p>
<p><strong>Asif Sarangi</strong><br/>
+44 (0) 207 3000 7861<br/>
<a href="https://{{companyWebsite}}">{{companyWebsite}}</a></p>
<p><br/></p>
<div style="${DISCLAIMER_STYLE}">
This email is confidential to the intended recipient, as are any attachments. If you are not the intended recipient, do not use, copy or disclose the information in any way or act in reliance on it, and notify the sender immediately, then delete it from your system. {{companyName}} accepts no liability (to the fullest extent permitted by law) for opinions, conclusions and other information in this message which do not relate to its official business. No contracts or official orders shall be concluded by means of this email. Neither {{companyName}} nor the sender accepts any responsibility for viruses and it is your responsibility to scan this email and any attachments for viruses. Please note that {{companyName}} reserves the right to monitor emails sent or received.
<br/><br/>
You received this email because you are connected with us or subscribed to our mailing list. You can unsubscribe at any time by clicking <a href="{{UNSUBSCRIBE_URL}}" style="color:#555555;text-decoration:underline;">Unsubscribe</a>.
</div>`

/** Just the signature + disclaimer, for inserting into an email already written. */
export const PLAIN_SIGNATURE_HTML = PLAIN_STARTER_HTML.slice(
  PLAIN_STARTER_HTML.indexOf('<p>Best regards,</p>'),
)
